<template>
  <div>
    <div class="banner">
      <img src="../../assets/images/product-banner_5.png" alt="" />
    </div>
    <div class="product-nav-wrap">
      <div class="product-nav">
        <a
          v-for="item in navList"
          :key="item.name"
          @click="navHandle(item.url)"
          >{{ item.name }}</a
        >
      </div>
    </div>
    <div class="survey" id="survey">
      <div
        class="survey-title fadeOutUp"
        ref="animate"
        :class="{ fadeInUp: animateData.animate }"
      >
        产品概况
      </div>
      <div class="survey-content">
        <div
          class="product fadeOutUp"
          v-for="item in product"
          :key="item.name"
          :class="{ fadeInUp: animateData[item.animate] }"
          :style="{
            transitionDelay: item.delay + 's',
          }"
          :ref="item.animate"
        >
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
        </div>
        <div class="dotted"></div>
        <img
          class="survey-left"
          src="../../assets/images/survey-left.png"
          alt=""
        />
        <img
          class="survey-right"
          src="../../assets/images/survey-right.png"
          alt=""
        />
      </div>
      <div class="survey-bottom">
        <img src="../../assets/images/product-img_5.png" alt="" />
        <div>
          场景化大数据分析<br />
          解决方案
        </div>
      </div>
    </div>
    <div class="features-wrap" id="features-wrap">
      <div
        class="features-title fadeOutUp"
        ref="animate1"
        :class="{ fadeInUp: animateData.animate1 }"
      >
        产品特点
      </div>
      <div class="features-content">
        <div
          class="features fadeOutUp"
          v-for="item in features"
          :key="item.name"
          :style="{
            backgroundImage: 'url(' + item.bg + ')',
            transitionDelay: item.delay + 's',
          }"
          :class="{ fadeInUp: animateData[item.animate] }"
          :ref="item.animate"
        >
          <div class="features-icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="features-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="scenes-wrap" id="scenes-wrap">
      <div
        class="scenes-title fadeOutUp"
        ref="animate2"
        :class="{ fadeInUp: animateData.animate2 }"
      >
        应用场景
      </div>
      <div class="scenes">
        <div
          class="scenes-item fadeOutUp"
          v-for="item in scenes"
          :key="item.name"
          :style="{
            transitionDelay: item.delay + 's',
          }"
          :class="{ fadeInUp: animateData[item.animate] }"
          :ref="item.animate"
        >
          <div style="height: 250px">
            <img :src="item.icon" alt="" />
          </div>
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isElementNotInViewport } from "../../utils/index.js";
export default {
  data() {
    return {
      navList: [
        {
          name: "产品概况",
          url: "survey",
        },
        {
          name: "产品特点",
          url: "features-wrap",
        },
        {
          name: "应用场景",
          url: "scenes-wrap",
        },
      ],
      product: [
        {
          name: "体系化设备库",
          icon: require("../../assets/images/product-icon_12.png"),
          animate: "animate3",
          delay: 0.1,
        },
        {
          name: "故障案例库",
          icon: require("../../assets/images/product-icon_13.png"),
          animate: "animate4",
          delay: 0.2,
        },
        {
          name: "大数据诊断模型",
          icon: require("../../assets/images/product-icon_14.png"),
          animate: "animate5",
          delay: 0.3,
        },
        {
          name: "高效分析引擎",
          icon: require("../../assets/images/product-icon_15.png"),
          animate: "animate6",
          delay: 0.4,
        },
      ],
      features: [
        {
          name: "数据标准",
          icon: require("../../assets/images/features_13.png"),
          bg: require("../../assets/images/features-bg_13.png"),
          animate: "animate7",
          delay: 0.1,
        },
        {
          name: "样本丰富",
          icon: require("../../assets/images/features_14.png"),
          bg: require("../../assets/images/features-bg_14.png"),
          animate: "animate8",
          delay: 0.2,
        },
        {
          name: "诊断智能",
          icon: require("../../assets/images/features_15.png"),
          bg: require("../../assets/images/features-bg_15.png"),
          animate: "animate9",
          delay: 0.3,
        },
      ],
      scenes: [
        {
          name: "电缆故障案例库与智能诊断",
          icon: require("../../assets/images/scenes_8.png"),
          animate: "animate10",
          delay: 0.1,
        },
        {
          name: "变压器设备画像",
          icon: require("../../assets/images/scenes_9.png"),
          animate: "animate11",
          delay: 0.2,
        },
        {
          name: "变压器知识图谱",
          icon: require("../../assets/images/scenes_10.png"),
          animate: "animate12",
          delay: 0.3,
        },
        {
          name: "变压器负荷预测",
          icon: require("../../assets/images/scenes_11.png"),
          animate: "animate13",
          delay: 0.1,
        },
        {
          name: "GIS大数据诊断分析",
          icon: require("../../assets/images/scenes_12.png"),
          animate: "animate14",
          delay: 0.2,
        },
        {
          name: "数据质量分析",
          icon: require("../../assets/images/scenes_13.png"),
          animate: "animate15",
          delay: 0.3,
        },
      ],
      animateData: {
        animate: false,
        animate1: false,
        animate2: false,
      },
    };
  },
  mounted() {
    this.scrollToTop();
    // 监听滚动事件
    window.addEventListener("scroll", this.scrollToTop);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    navHandle(id) {
      let target = document.getElementById(id);
      target.scrollIntoView();
    },
    // 滚动事件
    scrollToTop() {
      for (let i in this.$refs) {
        !isElementNotInViewport(this.$refs[i])
          ? (this.animateData[i] = true)
          : (this.animateData[i] = false);
      }
    },
    scenesArrowHandle(val) {
      if (val == 1) {
        this.$refs.swiper.prev();
      } else {
        this.$refs.swiper.next();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.banner {
  img {
    width: 100%;
    display: block;
  }
}

.scenes {
  margin-top: 28px;
  margin-bottom: -20px;
  flex-wrap: wrap;
  .scenes-item {
    width: 387px;
    box-shadow: 0px 2px 14px 9px rgba(77, 77, 77, 0.07);
    margin-bottom: 35px;
    img {
      display: block;
    }

    div {
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #243159;
    }
  }
}
</style>